
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAddressSearchResultDtoFormGroup() {
return new FormGroup({
    streetNumber: new FormControl<string | undefined>('', [Validators.required]),
    street: new FormControl<string | undefined>('', [Validators.required]),
    zip: new FormControl<string | undefined>('', [Validators.required]),
    city: new FormControl<string | undefined>('', [Validators.required]),
    country: new FormControl<string | undefined>(''),
    formattedAddress: new FormControl<string | undefined>('', [Validators.required]),
    latitude: new FormControl<number | undefined>(undefined),
    longitude: new FormControl<number | undefined>(undefined),
    canton: new FormControl<string | undefined>(''),
})
;
}
      